import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useSpeak2MeStore } from '@/store/speak2meStore';
import {
  COMPOSER_LLM_MODELS,
  DEFAULT_COMPOSER_LLM_MODEL_ID,
} from './ChatComposerModels';

interface ChatComposerModelSelectProps {
  disabled?: boolean;
}

export function ChatComposerModelSelect({ disabled }: ChatComposerModelSelectProps) {
  const selectedLlmModelId = useSpeak2MeStore((state) => state.selectedLlmModelId);
  const setSelectedLlmModelId = useSpeak2MeStore((state) => state.setSelectedLlmModelId);

  return (
    <Select
      value={selectedLlmModelId || DEFAULT_COMPOSER_LLM_MODEL_ID}
      onValueChange={(next) => setSelectedLlmModelId(next)}
      disabled={disabled}
    >
      <SelectTrigger
        data-testid="chat-composer-model-trigger"
        className="h-7 w-auto gap-1 border-0 bg-transparent px-2 text-xs text-muted-foreground shadow-none hover:bg-accent focus:ring-0 focus:ring-offset-0"
      >
        <SelectValue placeholder="Auto" />
      </SelectTrigger>
      <SelectContent align="start">
        {COMPOSER_LLM_MODELS.map((model) => (
          <SelectItem key={model.id} value={model.id} className="text-xs">
            {model.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
